import React, {useState, useEffect} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useSelector, useDispatch} from 'react-redux';
import {filterProvinces} from '../../../actions/provinces';
import EnhancedTable from '../../common/enhancedTable';
import {provinceCols} from '../../../utils/colTypes';
import CustomSnackbar from '../../common/customSnackbar';
import ProvinceDetail from './detail';

const Provinces = (props) => {
  const title = 'Provincias';
  const {page, rowsPerPage, order, orderBy, provinces, searchText, sending, dataLength, error, message} = useSelector(state => state.provinces);
  const [province, setProvince] = useState(null);
  const [isNew, setIsNew] = useState(false);


  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(filterProvinces(page, rowsPerPage, order, orderBy, searchText));
  }, []);

  const onSearch = (searchedText) => {
    dispatch(filterProvinces(page, rowsPerPage, order, orderBy, searchedText));
  };

  const onAdd = () => {
    setProvince({});
    setIsNew(true);
  };

  const onDetail = (id) => {
    const provinceLocal = provinces.filter(obj => obj.id === id)[0];
    setProvince(provinceLocal);
    setIsNew(false);
  };

  const handleChangeRowsPerPage = (rowsPerPageLocal) => {
    dispatch(filterProvinces(page, rowsPerPageLocal, order, orderBy, searchText));
  };

  const handleChangePage = (pageLocal) => {
    dispatch(filterProvinces(pageLocal, rowsPerPage, order, orderBy, searchText));
  };

  const onOrder = (orderLocal, orderByLocal) => {
    dispatch(filterProvinces(page, rowsPerPage, orderLocal, orderByLocal, searchText));
  };

  const getEditPermissions = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.update_profiles) {
        return true;
      }
    }
    return false;
  };

  const getCreatePermission = () => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile) {
      if (profile.permissions.create_profiles) {
        return true;
      }
    }
    return false;
  };

  const handleGoBack = () => {
    dispatch(filterProvinces(page, rowsPerPage, order, orderBy, searchText));
    setProvince(null);
    setIsNew(false);
  };

  const renderSnackBar = () => {
    if (message) {
      return (
        <CustomSnackbar
          variant={error !== null ? 'error' : 'success'}
          message={message}
        />
      );
    }
    return null;
  };

  const isLoading = sending;
  const hasEditPermission = getEditPermissions();
  const hasCreatePermission = getCreatePermission();
  const data = {
    rows: provinces,
    cols: provinceCols
  };
  const handlers = {
    onDetail,
    onAdd,
    onSearch,
    onOrder,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  };
  const config = {
    isDragable: false,
    isSelectable: false,
    hasEditPermission,
    hasCreatePermission,
    isFiterable: false,
    searchText: searchText || '',
    order: {
      by: orderBy,
      direction: order
    },
    pagination: {
      current: page,
      rowsPerPage,
      totalItems: dataLength
    },
    filters: {
      is: false
    }
  };
  return (
    isLoading === true ?
      <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} />
      :
      <div>
        {renderSnackBar()}
        {  
          !province ?
            <EnhancedTable
              title={title}
              data={data}
              handlers={handlers}
              config={config}
            />
            :
            <ProvinceDetail
              province={province}
              handleGoBack={handleGoBack}
              isLoading={isLoading}
              isNew={isNew}
            />
        }
      </div>
  );
};
  
export default Provinces;
